import React from "react";
import { SearchFilter } from "./SearchFilter";
import { SelectDisplay } from "./types";
export interface ProviderFilterProps {
    filters: SelectDisplay[];
    loading?: boolean;
    className?: string;
}
export const ProviderFilter: React.FC<ProviderFilterProps> = ({ filters, className, loading = false }) => {
    return (
        <div className={className ?? ""}>
            {filters.map(({ category, label, checkValues, options, onChange }, index) => {
                return (
                    <SearchFilter
                        key={category}
                        category={category}
                        label={label}
                        options={options}
                        checkedValues={checkValues}
                        onChange={onChange}
                        loading={loading}
                    />
                );
            })}
        </div>
    );
};
